import { createContext, useContext, useEffect, useState } from 'react';
import { getHoneypots } from './getHoneypots';
import { useSelector } from 'react-redux';
import { getAllStepsArray } from '../store/flow/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
const HoneypotContext = /*#__PURE__*/createContext({
  honeypots: {}
});
export const HoneypotContextWrapper = props => {
  const [honeypots, setHoneypots] = useState({});
  const {
    children
  } = props;
  const steps = useSelector(getAllStepsArray);
  useEffect(() => {
    const isHoneypotsEmpty = Object.keys(honeypots).length === 0;
    if (isHoneypotsEmpty && steps.length > 0) {
      setHoneypots(getHoneypots(steps));
    }
  }, [steps, honeypots]);
  return /*#__PURE__*/_jsx(HoneypotContext.Provider, {
    value: {
      honeypots
    },
    children: children
  });
};
export const useHoneypotContext = () => useContext(HoneypotContext);